import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { UnderwritingQuestionModel } from '@amfam/policy/models';

@Component({
  selector: 'ds-underwriting-question',
  templateUrl: './underwriting-question.component.html',
  styleUrls: ['./underwriting-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UnderwritingQuestionComponent implements OnInit {
  @Input() questionObject: UnderwritingQuestionModel;
  @Input() underWritingQuestionsForm: UntypedFormGroup;
  @Output() answerSelectedEvent = new EventEmitter<UnderwritingQuestionModel>();

  riskSelectionCtrl: AbstractControl;
  answerSelectionCtrl: AbstractControl;

  constructor() {}

  ngOnInit() {}

  answerClick(answer: boolean) {
    this.answerSelectedEvent.emit({
      question: this.questionObject.question,
      isAnswerYes: answer,
      id: this.questionObject.id
    });
  }
}
